// extracted by mini-css-extract-plugin
export var bg = "vids-module--bg--9b7c0";
export var right = "vids-module--right--0fdb2";
export var vids = "vids-module--vids--898a5";